import React, {useState} from 'react'
import {
  Grid, Box,
  TextField, Stepper, Step, Popper, Fade, Dialog, IconButton,
  DialogActions, DialogContent, DialogTitle,
  Paper, Typography, Autocomplete, RadioGroup, Checkbox, 
  Button, MenuItem, InputLabel,Select, FormControl, FormHelperText, FormGroup, 
  FormControlLabel, FormLabel,
} from '@mui/material';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

import CardContent from '@mui/material/CardContent';
// import CardActions from '@mui/material/CardActions';
// import Avatar from '@mui/material/Avatar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Radio from '@mui/material/Radio';
//import TabPanel from '@mui/lab/TabPanel';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';



import { DateTimePicker, DesktopDatePicker, DesktopDateTimePicker } from '@mui/x-date-pickers'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import AdapterDateFns from '@mui/lab/AdapterDateFns';


import { format, set } from 'date-fns';

import {usePlayContext} from '../utils/PlayContext';
import {getValidEndTimes, allStartTimes, allEndTimes, getAllDays, getWeekDayName} from '../utils/timeConfig'

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ px: 2, pb:0, pt:1, border:0, bgcolor:'none', m:0}}>
            {children}
          </Box>
        )}
      </div>
    );
  }

const ReoccurenceDialog = ({open, data, callback}) => {

    const {
        op, setOp,
        status, setStatus, appTitle, setAppTitle, 
        errorMessage, setErrorMessage, errorTitle, setErrorTitle,
        setTenantLogo, openSnackToast
      }=usePlayContext()
  
    const [reoccurencePattern, setReoccurencePattern]= useState(typeof data?.reoccurencePattern=== 'number' ? data?.reoccurencePattern: 1)

    const [reoccurencePatternError, setReoccurencePatternError]= useState('')
    const [meetingTimeError, setMeetingTimeError]= useState('')
    const [reoccurenceRangeError, setReoccurenceRangeError]= useState('')

    const [overallError, setOverallError]= useState('')

    
    const [startTime, setStartTime]= useState(data?.startTime ? data?.startTime: '09:00')
    const [startTimeError, setStartTimeError]= useState('')
    const [endTime, setEndTime]= useState(data?.endTime ? data.endTime: '10:00')
    const [endTimeError, setEndTimeError]= useState('')

    const [weeklyDays, setWeeklyDays]= useState(
        data?.weeklyDays ? data?.weeklyDays:
        [false,false, false, false,false, false, false,])
    const [dailyMode, setDailyMode]= useState(data?.dailyMode? data?.dailyMode: 'work')
    const [monthlyDays, setMonthlyDays]= useState(data?.monthlyDays?data?.monthlyDays: 1)
    const [monthlyDaysError, setMonthlyDaysError]= useState('')


    const [rangeType, setRangeType]= useState(data?.rangeType? data?.rangeType: 'occurence')
    const [rangeStart, setRangeStart]= useState( data?.rangeStart?data?.rangeStart:   new Date())
    const [rangeStartError, setRangeStartError]= useState('')
    const [rangeOccurence, setRangeOccurence]= useState(data?.rangeOccurence? data?.rangeOccurence: 5)
    const [rangeOccurenceError, setRangeOccurenceError]= useState('')

    const [rangeUntil, setRangeUntil]= useState(data?.rangeUntil?data?.rangeUntil: null)
    const [rangeUntilError, setRangeUntilError]= useState('')

    

    const onStartTimeChange=(e)=>
    {
        let newValue = e.target.value; 
        setStartTime(newValue)
        if (newValue && ( !Boolean(endTime) || newValue>=endTime) )
        {
            setEndTime(allEndTimes.find(x=>x>newValue))
        }
    }

    const handleWeekDaysChanged=(e, i)=>{
        let x = [...weeklyDays];
        x[i] = e.target.checked
        setWeeklyDays(x);
        console.log(x)
    }
    console.log(data)
    const onOkclicked=()=>{
        //alert(rangeStart+"--"+isNaN(rangeStart))
        let errNo=0;

        let request={}

        if (!startTime)
        {
            errNo++
            setStartTimeError('Start Time required')
        }
        else setStartTimeError('')
        

        if (!endTime)
        {
            errNo++
            setEndTimeError('End Time required')
        }
        else 
        {
            if (errNo===0 && (startTime>=endTime))
            {
                errNo++
                setEndTimeError('Invalid End Time')
            }
            else setEndTimeError('')
        }

        request = {...request, startTime, endTime, reoccurencePattern}


        //-----------------------------
        if (reoccurencePattern===0) //daily
        {
            setReoccurencePatternError('')
            request={...request, dailyMode}
        }
        else   if (reoccurencePattern===1) //weekly
        {
            request={...request, weeklyDays}
            if (!weeklyDays || weeklyDays.length<7 || !weeklyDays.some(Boolean))
            {
                errNo++
                setReoccurencePatternError('Please select at least on week day')
            }
            else
            {
                setReoccurencePatternError('')
            }
            
        }
        else   if (reoccurencePattern===2) //monthly
        {
            request={...request,monthlyDays}

            if (!Boolean(monthlyDays))
            {
                errNo++
                setMonthlyDaysError("Date is required")
            }
            else   if (isNaN(monthlyDays))
            {
                errNo++
                setMonthlyDaysError("Invalid Date of Month")
            }
            else if (monthlyDays<1)
            {
                errNo++
                setMonthlyDaysError("Invalid Date of Month")
            }
            else setMonthlyDaysError("")


        }


        let today=new Date()
        today =  new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate()
          );

        //Range
        if (!Boolean(rangeStart))
        {
            errNo++
            setRangeStartError("Start date is required")
        }
        else if (isNaN(rangeStart))
        {
            errNo++
            setRangeStartError("Invalid Start")
        }
        // else if (rangeStart.getFullYear()<today.getFullYear || 
        //             rangeStart.getMonth()<today.getMonth() || rangeStart.getDate()<today.getDate()) 
        else if(rangeStart.getTime()<today.getTime())
        {

            errNo++
            setRangeStartError("Start Time cannot be earlier than current time")

        }
        else setRangeStartError('')

        if (errNo>0) return

        if (rangeType==='occurence')
        {

            setRangeUntilError('')
            if (rangeOccurence<1)
            {
                errNo++
                setRangeOccurenceError("Too little")
            }
            else if (rangeOccurence>100)
            {
                errNo++
                setRangeOccurenceError("Too large")
            }
            else setRangeOccurenceError("")
        }
        else    //until
        {
            setRangeOccurenceError('')
            if (!Boolean(rangeUntil))
            {
                errNo++
                setRangeUntilError("Until is required" )
            }            
            else if (isNaN(rangeUntil))
            {
                errNo++
                setRangeUntilError("Invalid Until" )
            }
            else if (!isNaN(rangeStart) && rangeStart>=rangeUntil)
            {
                errNo++
                setRangeUntilError("Until is before start" )
            }
            else setRangeUntilError('')
        }

        if (errNo>0) return

        //

        let ddd = [];

        let i=0, total=0;

        let tmp=startTime.split(':')
        let start_h=parseInt(tmp[0])
        let start_m=parseInt(tmp[1])

        let tmp1=endTime.split(':')
        let end_h=parseInt(tmp1[0])
        let end_m=parseInt(tmp1[1])

        //alert("h=="+h+", m="+m)
        let mydate= new Date(rangeStart.getFullYear(), rangeStart.getMonth(), 
        rangeStart.getDate(), start_h, start_m, 59,999);
      //  alert("mydate00=="+mydate)

         tmp=new Date((new Date()).getTime()+1800*1000)
        if (mydate<tmp)
        {
            mydate= new Date(mydate.getFullYear(), mydate.getMonth(), mydate.getDate()+1)
        }

      //  alert("mydate0022=="+mydate)

        const start_date=mydate
        //alert("mydate=="+mydate)
        if (rangeType==='occurence')
        {
            while (total<rangeOccurence)
            {
                let year = mydate.getFullYear();
                let month=mydate.getMonth()
                let date=mydate.getDate()
                let weekday = mydate.getDay();
                if (reoccurencePattern===0)
                {
                    if (dailyMode==='work')
                    {
                        if (weekday===6)   //saturday
                        {
                            mydate = new Date(year, month, date+2);
                        }
                        else if (weekday===0)
                        {
                            mydate = new Date(year, month, date+1);
                        }
                    }
                    ddd.push(mydate)
                    mydate = new Date(mydate.getFullYear(), mydate.getMonth(), mydate.getDate()+1 )
                }
                else if (reoccurencePattern===1)  //weekly
                {
                    while (!weeklyDays[weekday])
                    {
                       // alert("loo-"+mydate)
                        mydate = new Date(year, month, date+1);
                        year=mydate.getFullYear()
                        month=mydate.getMonth()
                        date = mydate.getDate();
                        weekday=mydate.getDay()
                    }
                    ddd.push(mydate)
                    mydate = new Date(mydate.getFullYear(), mydate.getMonth(), mydate.getDate()+1 )
                }
                else if (reoccurencePattern===2)
                {
                    let shall=false
                    

                    do
                    {
                        let xx = parseInt(monthlyDays)
                        if (monthlyDays>31)
                        {
                            xx=(new Date(mydate.getFullYear(), mydate.getMonth()+1, 0)).getDate()
                        }
                        mydate = new Date(mydate.getFullYear(), mydate.getMonth(), xx,
                            start_h, start_m, 59,999
                        ) 
                        
                    //     alert("xxx="+mydate) 
                    //    alert("yyy="+start_date) 

                        if (shall=(mydate<start_date))
                        {
                            mydate = new Date(mydate.getFullYear(), mydate.getMonth()+1, 1)
                            
                        }
                    }
                    while (shall);                 
                    ddd.push(mydate)
                    //alert("pusher-"+mydate)  
                    mydate = new Date(mydate.getFullYear(), mydate.getMonth()+1, 1 )
                }
                else
                {
                    console.error("Invalid reoccurencePattern="+reoccurencePattern)
                    throw new Error("Invalid reoccurencePattern="+reoccurencePattern)
                }

                total+=1
            }
        }
        else
        {
            let end_date= new Date(rangeUntil.getFullYear(), rangeUntil.getMonth(), 
                    rangeUntil.getDate(), 23, 59, 59,999)

            while (mydate<end_date)
            {
                let year = mydate.getFullYear();
                let month=mydate.getMonth()
                let date=mydate.getDate()
                let weekday = mydate.getDay();
                
                if (reoccurencePattern===0)
                {
                    if (dailyMode==='work')
                    {
                        if (weekday===6 || weekday===0)   //saturday
                        {
                            mydate = new Date(year, month, date+(weekday===0?1:2));
                            continue
                        }
                    }
                    ddd.push(mydate)
                    mydate = new Date(year, month, date+1 )
                }
                else if (reoccurencePattern===1)  //weekly
                {
                    if (weeklyDays[weekday])
                    {
                        ddd.push(mydate)
                    }
                    mydate = new Date(year, month, date+1 )
                }
                else if (reoccurencePattern===2)  //month
                {
                    let xx = parseInt(monthlyDays)
                    if (monthlyDays>31)
                    {
                        xx=(new Date(mydate.getFullYear(), mydate.getMonth()+1, 0)).getDate()
                    }
                    mydate = new Date(mydate.getFullYear(), mydate.getMonth(), xx) 
                        
                     if (mydate<end_date && mydate>start_date) 
                     {
                        ddd.push(mydate)
                        //alert("pusher-"+mydate)
                     }  
                    mydate = new Date(mydate.getFullYear(), mydate.getMonth()+1, 1 )
                }
                else
                {
                    console.error("invalid ReoccurrencePattern="+reoccurencePattern)
                    throw new Error("invalid Reoccurernce Pattern="+reoccurencePattern)
                }

            }
        }

        console.log('dddddddddddddddddddddddddddddd::')
        console.log(ddd)

        
        if (ddd.length===0)
        {
            setOverallError("No effective dates selected")
            return
        }
        else
        {
            setOverallError('')
        }
        let dd00 = ddd.map(d=>{

            let n= format(d, "dd/MM/yyyy")+' '+ getWeekDayName(d)+ ' '+startTime+ ' - '+endTime


            let startTm11 = new Date(d.getFullYear(), d.getMonth(), d.getDate(), start_h, start_m,0,0);
            let endTm11= new Date(d.getFullYear(), d.getMonth(), d.getDate(), end_h, end_m,0,0);

            let x = {

                startTm: format(startTm11, "yyyy-MM-dd HH:mm"),
                endTm: format(endTm11, "yyyy-MM-dd HH:mm"),
                text: n,
            }
            return x;
        })
        console.log('dddddddddddddddd00000000000000000000000::')
        console.log(dd00)

        const my_weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

        let message = '';
        let result={

            startTime,
            endTime,

            reoccurencePattern,
            rangeType,
            rangeStart,
        }
        if (reoccurencePattern==0)
        {
            result.dailyMode=dailyMode;
            message+= (dailyMode==='work') ? 'Every Monday-Friday': 'Every day' 
        }
        else   if (reoccurencePattern==1)
        {
            result.weeklyDays=weeklyDays;
            let nnn=[]
            weeklyDays.forEach((w, i) => {
                if (i<7 && w) nnn.push(my_weekday[i])
            });

            let yy = nnn.join(',');
            if (nnn.length>1)
            {
                const lastIndex = yy.lastIndexOf(',');
                if (lastIndex>0)
                {
                    yy =yy.substring(0, lastIndex) + ' and '+yy.substring(lastIndex + 1);
                }

            }
            message+= 'Every '+ yy

        }
        else   if (reoccurencePattern==2)
        {
            result.monthlyDays=monthlyDays;
            message+= (monthlyDays>31 ?'last day' : monthlyDays) + ' of Every month' 
        }


        message+= ', Effective from '+ format(ddd[0], 'dd/MM/yyyy') + ' until '+format(ddd[ddd.length-1], 'dd/MM/yyyy')
        message+= ' '+ startTime+' to '+endTime;
        

        if (rangeType==='occurence')
        {
            result.rangeOccurence=rangeOccurence
        }
        else
        {
            result.rangeUntil=rangeUntil
        } 
        
        result.message=message
        result.days=dd00

        if (result.days && result.days.length>50)
        {
            setOverallError("Occurences ("+result.days.length+") exceeds 50")
            //alert(50505)
            return
        }

        console.log('final result::')
        console.log(result)

        if (callback)
        {
            callback(result)
        }

    }


    return (
<Dialog open={open}
    keepMounted
    fullScreen

>
    <DialogTitle>
        
        <Typography variant='h6'>Make recurrence</Typography>

            <IconButton
          aria-label="close"
          onClick={e=>setOp('')}
          sx={{
            position: 'absolute',
            right: 12,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
            <CloseIcon/>
            </IconButton>

    </DialogTitle>
    <DialogContent sx={{p:1}}>
        <Box>
            <Card raised={false} sx={{width:'100%', border:1, borderColor:'#aaaaaa'}}>

            <CardHeader
                    sx={{py:0, mb:0}}
                    title={<Typography variant='body1'><strong>Meeting Time</strong></Typography>}
                />
            <CardContent sx={{m:0,pt:1}}>
            <Grid
                  container
                  spacing={1}
                  sx={{p:0,m:0}}
                >
                <Grid item xs={6} sm={3} lg={2}>
                    <FormControl fullWidth required
                        error={Boolean(startTimeError)}
                        size="small">
                        <InputLabel id="id-start-label">Start Time</InputLabel>
                        <Select
                            
                            labelId="id-start-label"
                            id="id-start"
                            value={startTime}
                            label="Start Time"
                            onChange={onStartTimeChange}
                        >
                        {
                            allStartTimes.map(x=><MenuItem key={x} value={x}>{x}</MenuItem>)
                        }
                        </Select>
                        <FormHelperText>{startTimeError}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <FormControl fullWidth required 
                        error={Boolean(endTimeError)}
                        size="small"
                        >
                        <InputLabel id="id-end-label">End Time</InputLabel>
                        <Select
                            
                            labelId="id-end-label"
                            id="id-end"
                            value={endTime}
                            label="End Time"
                            onChange={e=>setEndTime(e.target.value)}
                        >
                            
                        {
                            getValidEndTimes(startTime).map(
                                x=><MenuItem key={x} value={x}>{x}</MenuItem>
                                )

                        }
                        </Select>
                        <FormHelperText>{endTimeError}</FormHelperText>
                    </FormControl>
                </Grid>
                
                </Grid>
                </CardContent>
                {
                    Boolean(meetingTimeError)&&
                    <Typography 
                        sx={{p:0,m:0, border:1, borderColor:'#888888'}}
                        variant='subtitle1'
                        color='error.main' 
                        textAlign={'center'}
                        >{meetingTimeError}</Typography>
                }
                
            </Card>

            <Card raised={false} sx={{width:'100%', border:1, mt:1, bgcolor:'white', pb:0}}>
            
                <CardHeader
                    sx={{py:0, mb:0}}
                    title={<Typography variant='body1'><strong>Recurrence Pattern</strong></Typography>}
                />
                <CardContent sx={{m:0,pt:1}}>
                <Box sx={{ border: 1, borderColor: 'divider', p:0, m:0 }}>
                  
                <Tabs
                    //orientation="vertical"
                    variant="scrollable"
                    value={reoccurencePattern}
                    onChange={(event, newValue)=>{ setReoccurencePattern(newValue); setReoccurencePatternError(''); }}
                    aria-label="Vertical tabs example"
                    sx={{ borderRight: 1, borderColor: 'divider', bgcolor:'none' ,
                            p:0, m:0,
                        }}
                >
                    <Tab label="Daily"  sx={{textTransform:'none'}} />
                    <Tab label="Weekly"  sx={{textTransform:'none'}}/>
                    <Tab label="Monthly"  sx={{textTransform:'none'}}/>
                </Tabs>
                </Box>
                <TabPanel value={reoccurencePattern} index={0}>
                    <FormControl>
                        <RadioGroup
                                size='small'
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                onChange={event => setDailyMode(event.target.value)}
                                value={dailyMode}
                                >
                            <FormControlLabel 
                                size='small'
                                sx={{ mr:{xs:5, sm:8, md:12}}}
                                value="work" control={<Radio />} label="Every Monday-Friday" />

                            <FormControlLabel 
                                size='small'
                                value="all" control={<Radio />} label="Every Day" />
            
                        </RadioGroup>
                    </FormControl>
                </TabPanel>
                <TabPanel value={reoccurencePattern} index={1} sx={{bgcolor:'green'}}>
                    <FormControl component="fieldset" 
                        sx={{border:0, 
                            bgcolor:'none',
                            borderColor:'divider',
                            px:1}}>
                    
                    <FormGroup aria-label="position" row>
                        <FormControlLabel
                            checked={weeklyDays[1]}
                            size='small'
                            sx={{width:134}}
                            value={1}
                            control={<Checkbox size='small'
                                onChange={e=>handleWeekDaysChanged(e,1)}
                                />}
                            label="Monday"
                            labelPlacement="end"
                            
                            />
                        <FormControlLabel
                            value={2}
                            checked={weeklyDays[2]}
                            sx={{width:134}}
                            size='small'
                            control={<Checkbox size='small'
                            onChange={e=>handleWeekDaysChanged(e,2)}
                            />}
                            label="Tuesday"
                            labelPlacement="end"
                            />
                        <FormControlLabel
                            value={3}
                            checked={weeklyDays[3]}
                            sx={{width:134}}
                            size='small'
                            control={<Checkbox size='small'
                                onChange={e=>handleWeekDaysChanged(e,3)}
                            />}
                            label="Wednesday"
                            labelPlacement="end"
                            />
                        <FormControlLabel
                            value={4}
                            checked={weeklyDays[4]}
                            sx={{width:134}}
                            size='small'
                            control={<Checkbox size='small'
                                 onChange={e=>handleWeekDaysChanged(e,4)}
                            />}
                            label="Thursday"
                            labelPlacement="end"
                            
                            />
                        <FormControlLabel
                            value={5}
                            checked={weeklyDays[5]}
                            size='small'
                            sx={{width:134}}
                            control={<Checkbox size='small'
                                onChange={e=>handleWeekDaysChanged(e,5)}
                            />}
                            label="Friday"
                            labelPlacement="end"
                            
                            />
                        <FormControlLabel
                            value={6}
                            checked={weeklyDays[6]}
                            size='small'
                            sx={{width:134}}
                            control={<Checkbox size='small'
                            onChange={e=>handleWeekDaysChanged(e,6)}
                            />}
                            label="Saturday"
                            labelPlacement="end"
                            
                            />
                        <FormControlLabel
                            value={0}
                            checked={weeklyDays[0]}
                            
                            sx={{width:134}}
                            size='small'
                            control={<Checkbox size='small'
                            onChange={e=>handleWeekDaysChanged(e,0)}/>}
                            label="Sunday"
                            labelPlacement="end"
                            
                            />

                    </FormGroup>
                    </FormControl>
                </TabPanel>
                <TabPanel value={reoccurencePattern} index={2}>
                    <FormControl required
                        sx={{width:200, mt:1}} 
                        error={Boolean(monthlyDaysError)}
                        size="small">
                        <InputLabel id="id-monthly-days-label">Date of Month</InputLabel>
                        <Select
                            
                            labelId="id-monthly-days-label"
                            id="id-monthly-days"
                            value={monthlyDays}
                            label="Date of Month"
                            onChange={e=>setMonthlyDays(parseInt(e.target.value))}
                        >
                        {
                            getAllDays().map(x=><MenuItem key={x} value={x}>{x}</MenuItem>)
                        }
                        <MenuItem  value={100}>Last Date</MenuItem>
                        </Select>
                        <FormHelperText>{monthlyDaysError}</FormHelperText>
                    </FormControl>
                        
                </TabPanel>
                
                </CardContent>
                {
                    Boolean(reoccurencePatternError)&&
                    <Typography 
                        sx={{p:0,m:0, border:0, borderColor:'#888888'}}
                        variant='subtitle1'
                        color='error.main' 
                        textAlign={'center'}
                        >{reoccurencePatternError}</Typography>
                }
                
            </Card>
            <Card raised={false} sx={{width:'100%', border:1, mt:1}}>
            
                <CardHeader
                    sx={{py:0, mb:0}}
                    title={<Typography variant='body1'><strong>Range of Recurrence</strong></Typography>}
                />
                <CardContent sx={{mt:1,x:1, bgcolor:'none'}} 
                        style={{paddingBottom:'8px', paddingTop:'0px'}}>
                
                <Grid
                  container
                  spacing={2}
                  sx={{p:0,m:0, bgcolor:'none'}}
                >
                    <Grid item xs={12} md={5} lg={5}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                        value={rangeStart}
                        disablePast
                        size='small'
                        
                        inputFormat="dd/MM/yyyy"
                        onChange={(newValue) => {  setRangeStart(newValue);}}
                        renderInput={(props) => 
                                <TextField {...props} 
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                          error={Boolean(rangeStartError)}
                                          required
                                  sx={{maxWidth:200}} 
                                helperText={ rangeStartError}
                                      label="Start"
                                      //value={nestartDateTime}
                                      //onChange={(newValue) => {  setStartDateTime(newValue);}
                                    
                                    
                    
                                />}
                                />
                    </LocalizationProvider>
                    </Grid>
                     <Grid item xs={12} md={3} lg={2}>
                        <Box sx={{p:0, display:'flex'}}>
                            <Radio
                                value='occurence'
                                checked={rangeType==='occurence'}
                                onChange={e=>setRangeType(e.target.value)}
                            ></Radio>
                            <TextField 
                                    sx={{width:150}}
                                    required={rangeType==='occurence'}
                                    size='small'
                                    type='number'
                                    label='Occurance'
                                    disabled={rangeType!=='occurence'}
                                    value={rangeOccurence}
                                    error={Boolean(rangeOccurenceError)}
                                    onChange={e=>{
                                        let x= parseInt(e.target.value)
                                         
                                        setRangeOccurence(x.toString())
                                    }}
                                    helperText={rangeOccurenceError}
                                    InputProps={{ inputProps: { min: 2, max: 10 } }}
                                    >
                                </TextField>
                        </Box>     
                    </Grid>
                    <Grid item xs={12} md={3} lg={3}>
                    <Box sx={{p:0, display:'flex'}}>
                       <Radio
                            value='until'
                            checked={rangeType==='until'}
                            onChange={e=>setRangeType(e.target.value)}
                       
                       ></Radio>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                value={rangeUntil}
                                disablePast
                                size='small'
                                disabled={rangeType!=='until'}
                                inputFormat="dd/MM/yyyy"
                                onChange={(newValue) => {  setRangeUntil(newValue);}}
                                renderInput={(props) => 
                                        <TextField {...props} 
                                        //disabled={rangeType!=='until'}
                                        required={rangeType==='until'}
                                        size='small'
                                        error={Boolean(rangeUntilError)}
                                                
                                        sx={{maxWidth:200}} 
                                                //helperText={Boolean(startDateTimeError)? startDateTimeError : 'Start date & time' }/>}
                                            label="Until"
                                            //value={nestartDateTime}
                                            //onChange={(newValue) => {  setStartDateTime(newValue);}
                                            
                                            helperText={rangeUntilError}  
                            
                                        />}
                                        />
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                </Grid>
                </CardContent>
                {
                    Boolean(reoccurenceRangeError)&&
                    <Typography 
                        sx={{p:0,m:0, border:1, borderColor:'#888888'}}
                        variant='subtitle1'
                        color='error.main' 
                        textAlign={'center'}
                        >{reoccurenceRangeError}</Typography>
                }
             
            </Card>

            <Box sx={{mt:1,display:'flex', justifyContent:'space-around', width:'100%'}}>
                    <Typography variant='h5' color='error'>{overallError}</Typography>
            </Box>
            <Card raised={false} sx={{width:'100%', border:0, mt:0, p:1}}>
           
                <Box sx={{mt:0,display:'flex', justifyContent:'space-around'}}>
                    <Button
                        variant="outlined"
                        onClick={onOkclicked}
                        sx={{textTransform:'none'}}
                        >Apply </Button>
                    <Button
                        variant="outlined"
                        color='success'
                        sx={{textTransform:'none'}}
                        onClick={e=>setOp('')}
                        >Cancel</Button>

                </Box>
            </Card>
        </Box>
    </DialogContent>       
    {/** 
        <DialogActions>
            
        </DialogActions>
    */}        
    </Dialog>
    )
}

export default ReoccurenceDialog